export default __webpack_public_path__ + "static/media/carleft.9d976a0d.png";